<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleClose">
    <table-form :dataSource="dataSource" ref="form" :tableData="data"></table-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm";
import { step3Agency } from "@/conf/Report-angency";
import { nation, selectDic, addUpFundNewInveste } from "common/js/api";

export default {
  components: {
    TableForm
  },

  props: ["dialogVisible", "title", "data", "codeId"],

  data() {
    return {
      dataSource: step3Agency,
      dialogFormVisible: false,
      formData: {},
      isManager: true
    };
  },

  mounted() {
    this.getnation();
    this.getSelect();
  },

  methods: {
    async getnation() {
      const result = await nation(0);
      this.dataSource[4].options = result.result.map(item => ({
        label: item.district,
        value: item.district
      }));
    },

    async getSelect() {
      const query = "5,6";
      const result = await selectDic(query);
      const { INVEST_INDUSTRY } = result.result;

      this.converSelect(INVEST_INDUSTRY, 3);
    },

    converSelect(option, index) {
      option.forEach(item => {
        let data = {
          label: item,
          value: item
        };
        this.dataSource[index].options.push(data);
      });
    },

    async submit() {
     
      const isValidate = this.$refs.form.submitForm();
      if (!isValidate) return false;
      let form = this.$refs.form.form;
   

      // code id
      form.reportCode = this.codeId;
      if (this.title.includes("编辑")) {
        form.id = this.data.id;
      }
      
      await addUpFundNewInveste(this.title, form);
      const message = this.title.includes("添加") ? "添加" : "编辑";
      this.$message({
        message: `年内拟新增投资者情况${message}成功!`,
        type: "success"
      });
      this.$emit("reload");
      this.handleClose();
    },

    handleClose() {
      this.formData = {};
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    }
  }
};
</script>

